import { CbhFeatureFlag, useCbhFlag } from "@src/appV2/FeatureFlags";

export function useIsJobInterviewsEnabled(): boolean {
  return useCbhFlag(CbhFeatureFlag.ROLLOUT_JOB_INTERVIEWS, {
    defaultValue: false,
  });
}
